import React, { useState, useCallback, FormEvent } from 'react';
import UploadMovie from '../UploadMovie';
import { uuid } from 'uuidv4'
import filesize from 'filesize';
import FileList from '../FileList';
import api, { cancelToken } from '../../Services/api';
import { useAblContext } from '../../Hooks/useAblContext';
import { Button } from 'react-bootstrap';

interface MovieFormProps {
  onSuccess: Function,
  video?:{
    companyName: string,
    movieName: string,
    url?: string,
    createDate: Date
  }
}

const MovieForm: React.FC<MovieFormProps> = ({ onSuccess, video }) => {
  const [files, setFiles] = useState<any[]>([]);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [canCancel, setCanCancel] = useState<boolean>(true);
  const [buttonLabel, setButtonLabel] = useState<string>('PROSSIGA PARA O UPLOAD');
  const source = cancelToken;

  const abl = useAblContext();

  const handleAcceptFile = async (acceptFile: any) =>{
    setDisabled(false);

    const uploadedFile = acceptFile.map((file: any) => ({
      file,
      id: uuid(),
      name: file.name,
      readableSize: filesize(file.size),
      preview: URL.createObjectURL(file),
      progress: 0,
      uploaded: false,
      error: false,
      url: null
    }));

    setFiles(uploadedFile)
  }

  const updateFile = (id:string, data: any) => {

    setFiles(files.map(uploadedFile => {
      return id === uploadedFile.id ?
        { ... uploadedFile, ... data}
        : uploadedFile;
    }));

  }

  const handleOnSuccess = React.useCallback(() => {
    onSuccess();
  }, [])

  const processUpload = async (uploaded: any) => {
    try{
    const data = new FormData();
    data.append('file', uploaded.file, uploaded.name.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
    setCanCancel(false);
    const response = await api.post('video', data, { headers: {
      authorization: abl.token },
      onUploadProgress: (e: ProgressEvent) => {
        const progress = Math.round((e.loaded * 100) / e.total);

        updateFile(uploaded.id, {progress} )
      },
      cancelToken: source.token
    })
    setFiles(files.map(uploadedFile => {
      return uploaded.id === uploadedFile.id ?
        { ... uploadedFile, ... { uploaded: true, url: response.data.url }}
        : uploadedFile;
    }));
    handleOnSuccess();
   } catch(err) {
     console.log(err);
     uploaded.progress = 0;
     setCanCancel(true);
     if(err.message === 'CANCEL'){
        setFiles([]);
        return;
     }
      alert("Ocorreu um erro no seu upload! Por favor tente novamente.")
   }
  }

  const handleOnPress = useCallback((e: FormEvent) => {
    e.preventDefault();
    setDisabled(true);
    setButtonLabel('Aguarde o envio');
    files.forEach(processUpload)
  }, [files])

  const handleDeleteFileBeforeSend = () => {
    setFiles([]);
  }



  return(
    <div className="row">
      <div className="col-md-12">
        <div className="form-group">
          <form>
            <div className="form-group">
              <label>Selecione o arquivo do Filme {video?.movieName} (limite máximo de 30GB)</label>
                <UploadMovie onAcceptFile={handleAcceptFile} acceptFiles={['video/mp4',
                    'video/x-msvideo',
                    'video/quicktime',
                    'application/sql',
                  ]}
                    message={files.length ?"PROSSIGA PARA O UPLOAD" :"ARRASTE SEU FILME OU CLIQUE AQUI"}
                    maxSize={460173244200}
                    maxFiles={1}
                />
                  { !! files.length && <FileList files={files} showUploadProgress canRemoveFile removeFileBeforeSend={() => handleDeleteFileBeforeSend()}/>}
            </div>

            <Button variant="dark" disabled={disabled} onClick={(e) => handleOnPress(e)}>{disabled ? buttonLabel : 'ENVIAR'}</Button>
            <Button style={{marginLeft: 10}} variant="dark" disabled={canCancel} onClick={() => source.cancel('CANCEL')}>Cancelar envio</Button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default MovieForm;
